var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('view-selector'),_c('input-sample-dashboard',{style:(_vm.showSampleDashboard)}),_c('input-heatmap',{style:(_vm.showHeatmap)}),_c('input-boxplot',{style:(_vm.showBoxplot)}),_c('input-scatterplot',{style:(_vm.showScatterplot)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }